import React from 'react';
import clsx from 'clsx';

import { CustomerProfileGroup } from '@widgets/customer/profile/customer-profile.group';
import { CustomerGroup } from '@widgets/cabinet/applicationCard/types';
import { Element } from '@shared/interfaces/element.interface';

interface CustomerProfileGroupsProps extends Element {
  groups: CustomerGroup[];
}

export const CustomerProfileGroups: React.FC<CustomerProfileGroupsProps> = ({ groups, className }) => {
  return (
    <div className={clsx('flex flex-col items-start space-y-2', className)}>
      {groups.map(({ name, status }) => (
        <CustomerProfileGroup key={name} name={name} status={status} />
      ))}
    </div>
  );
};
